import { render, staticRenderFns } from "./TheNavbarButton.vue?vue&type=template&id=317f21c5&scoped=true&"
import script from "./TheNavbarButton.vue?vue&type=script&lang=js&"
export * from "./TheNavbarButton.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarButton.vue?vue&type=style&index=0&id=317f21c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317f21c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
